export default __webpack_public_path__ + "static/step-2-4d78069d069c316f8086677c2f6991c7.png";